import { render, staticRenderFns } from "./uToast.vue?vue&type=template&id=f421ed3c&scoped=true"
import script from "./uToast.vue?vue&type=script&lang=js"
export * from "./uToast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f421ed3c",
  null
  
)

export default component.exports